import NameForm from "../../components/ui/name-form.ui";

export default function NameFormScreen() {
  return (
    <div className="flex justify-center items-center w-full h-screen">
      <NameForm />
    </div>
  );
}
